module.exports = __webpack_public_path__ + "img/document-emptystate.1b21acdb.svg";